<template>
    <div class="distribute-frame">
        <a class="anchor" id="dotJkgzgs"></a>
        <div class="home-title-bt">
            <div class="home-t-bg">Localized Service Footprint</div>
            <p>属地化服务版图</p>
        </div>
        <div class="distribute-main">
            <div class="distribute-title wow fadeInUp animated" data-wow-duration="1s" data-wow-delay=".2s">
                <p>百昌科技采取上海、北京双总部运营模式,并在全国范围内开设了17家控股子公司，形成了覆盖全国的服务网络。各子公司均与当地大部分金融机构建立了深入的合作关系,精准提供属地化服务,真正打通特殊资产处置最后一公里。随着全国加盟商网络的逐步构建与拓展,集团的基础服务设施将更加完善。</p>
            </div>
        </div>
        <div class="map-frame">
            <div class="mapArea">
                <div class="company-frame">
                    <company :type="true"></company>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import company from  '../../cooperate/components/company'
    export default {
        name: "distribute",
        components: {
            company
        },
        mounted() {
            this.$nextTick(() => {
                new this.$wow.WOW().init();
            });
        },
    }
</script>

<style scoped lang="scss">
    .distribute-frame{
        position: relative;
        height: 1080px;
        .anchor{
            position: absolute;
            opacity: 0;
            top: -200px;
        }
        .distribute-main{
            padding-top: 60px;
           .distribute-title{
               font-size: 18px;
               font-family: 'SourceHanSansCN-Regular';
               font-weight: 400;
               color: #333333;
               line-height: 36px;
               text-align: center;
           }
        }
        .map-frame{
            position: relative;
            margin-top: 30px;
            .mapArea{
                width: 1980px;
                position: absolute;
                left: 50%;
                margin-left: -990px;
                top: 0;
                background-color: #f3f3f3;
                .company-frame{
                    min-width: 1200px;
                    margin: 0 auto;
                    background-color: #f3f3f3;
                }
            }
        }
    }
</style>
